import React, { FunctionComponent } from 'react'
import PuxMediaSelector, {
  PuxMediaSelectorType,
} from 'Root/Shared/components/content/mediaImage/PuxMediaSelector'
import PuxButton from 'Shared/components/PuxButton/PuxButton'
import { dt } from 'Shared/utils/dynamicRS'
import { getLocalizedUrl } from 'Shared/utils/localeURL'

export interface PuxLinkGalleryItemType {
  puxMediaSelector: PuxMediaSelectorType
  linkGalleryItemShowButton?: boolean
  linkGalleryItemUrl: {
    url: [string]
    internal: [boolean]
  }
}

const PuxLinkGalleryItem: FunctionComponent<PuxLinkGalleryItemType> = (
  props
) => {
  const buttonText = dt(`Link.Gallery.Item.Button.Text`)
  const url = props.linkGalleryItemUrl.url[0]
  const isInternal = props.linkGalleryItemUrl.internal[0]
  const showButton = props.linkGalleryItemShowButton && url != null
  const classes = [`Gallery-item`, `Gallery-item--link`]

  if (showButton) {
    classes.push(`has-button`)
  }

  return (
    <div className={classes.join(` `)}>
      {url != null ? (
        <a
          href={isInternal ? getLocalizedUrl(url) : url}
          target={isInternal ? `_self` : `_blank`}
          rel={isInternal ? undefined : `noopener`}
          className='gallery-item-logo'
        >
          <PuxMediaSelector
            {...props.puxMediaSelector}
            width={150}
            height={50}
          />
        </a>
      ) : (
        <div className='gallery-item-logo'>
          <PuxMediaSelector
            {...props.puxMediaSelector}
            width={150}
            height={50}
          />
        </div>
      )}
      {showButton ? (
        <PuxButton
          buttonType='ghost'
          buttonSize='small'
          buttonClassName='gallery-item-button'
          buttonNewWindow={!isInternal}
          buttonLink={{
            url: [url],
            internal: [isInternal],
            text: [buttonText],
          }}
        />
      ) : null}
    </div>
  )
}

export default PuxLinkGalleryItem
